/* eslint-env browser */

const DomHelper = require('../../../../client/clientjs/dom-helper.js')
const PubSub = require('../../../../client/clientjs/services/pub-sub')

module.exports = () => {
  const appBar = DomHelper.query('#app-bar')
  const appBarSecondLevel = DomHelper.query('.navbar-second-level')

  const getTotalAppBarHeight = () => {
    let result = 0
    if (appBar) {
      result += appBar.clientHeight
    }
    if (appBarSecondLevel) {
      result += appBarSecondLevel.clientHeight
    }
    return result
  }

  if (appBar) {
    const hamburger = DomHelper.query(appBar, '.navbar-burger')
    const background = DomHelper.query('#burger-menu-background')
    const menu = DomHelper.query(appBar, '.navbar-menu')
    if (hamburger && menu && background) {
      const toggle = () => {
        DomHelper.toggleClass(appBar, 'is-forced-non-transparent')
        DomHelper.toggleClass(background, 'is-hidden')
        DomHelper.toggleClass(menu, 'is-active')
        DomHelper.toggleClass(hamburger, 'is-active')
      }
      background.onclick = toggle
      hamburger.onclick = toggle
    }
  }

  const subHeaderContainer = DomHelper.query('.subheader-hero')
  const subHeader = DomHelper.query('.subheader-hero #subheader-fixed-bar')
  if (subHeaderContainer && subHeader) {
    DomHelper.addClass(appBarSecondLevel, 'has-no-box-shadow')

    const coverPic = DomHelper.query(subHeader, '.is-overlay.has-object-fit-cover')
    const profilePic = DomHelper.query(subHeader, '.has-object-fit-contain')
    const bottomMain = DomHelper.query(subHeader, '.bottom-main')
    const bottomContainer = DomHelper.query(subHeader, '.bottom-container > .columns')
    let minPageYOffset = -1
    let didScroll = false

    const handleSubHeader = function() {
      didScroll = true
      /*
      if (window.pageYOffset > 210) {
        DomHelper.addClass(subHeader, 'is-small');
        if (profilePic) {
          DomHelper.removeClass(profilePic, 'fadeInDown animated faster');
          DomHelper.addClass(profilePic, 'fadeInUp animated faster');
        }
      } else {
        DomHelper.removeClass(subHeader, 'is-small');
        if (profilePic) {
          DomHelper.removeClass(profilePic, 'fadeInUp animated faster');
          DomHelper.addClass(profilePic, 'fadeInDown animated faster');
        }
      } */

      // remove is-hidden-on-scroll in internal-scrollable-cover-mustache to remove this feature
      const limitForLockedAppBar =
        getTotalAppBarHeight() +
        (DomHelper.hasClass(bottomMain, 'is-hidden-on-scroll') ? 0 : bottomContainer.clientHeight)
      const subHeaderContainerBottomPos =
        subHeaderContainer.getBoundingClientRect().top + subHeaderContainer.clientHeight

      if (limitForLockedAppBar < subHeaderContainerBottomPos) {
        DomHelper.removeClass(subHeader, 'is-locked')
        if (coverPic) {
          const transform = Math.round(window.pageYOffset / 2)
          coverPic.style.transform = `translate3d(0px, ${transform}px, 0px)`
        }
      } else {
        if (minPageYOffset === -1 || window.pageYOffset < minPageYOffset) {
          minPageYOffset = window.pageYOffset
        }
        DomHelper.addClass(subHeader, 'is-locked')
        if (coverPic) {
          coverPic.style.transform = 'translate3d(0px, 0px, 0px)'
        }
      }
    }
    DomHelper.on(window, 'scroll', handleSubHeader)
    handleSubHeader()

    PubSub.sub('scrollableCoverTabClick', ({ args }) => {
      // scroll if needed !
      if (subHeader) {
        if (DomHelper.hasClass(subHeader, 'is-locked')) {
          if (minPageYOffset !== -1) {
            DomHelper.scrollTo('html', minPageYOffset)
          } else {
            DomHelper.scrollTo('html', 0)
          }
        }
      }
      if (!window.initialState.titleDoNotFollowTabs && args && args.longTitle) {
        const mainTitle = DomHelper.query('#internal-scrollable-title-h1')
        const subtitle = DomHelper.query('#internal-scrollable-title-h1 .subtitle')
        mainTitle.innerHTML = args.longTitle + (subtitle && subtitle.outerHTML ? `<br/>${subtitle.outerHTML}` : '')
      }
    })

    /*
    // TODO: use this if we want to hide top bar sometimes
    let lastScrollTop = 0;
    const delta = 5;

    setInterval(() => {
      if (didScroll) {
        const st = window.pageYOffset;
        if (Math.abs(lastScrollTop - st) >= delta) {
          if (st > lastScrollTop && st > getTotalAppBarHeight() + bottomContainer.clientHeight) {
            // scroll down, hide top
            DomHelper.addClass(subHeader, 'is-scrolled');
          } else {
            // scroll up
            DomHelper.removeClass(subHeader, 'is-scrolled');
          }
        }
        lastScrollTop = st;
        didScroll = false;
      }
    }, 200);
    */
  }
}
